import { UNITED_STATES_LIST } from 'client/data/constants/united-states-list';

export const LEASE_DEALS_PATH = '/lease-deals';
export const LEASE_DEALS_STATE_PATH = `/lease-deals/:state(${UNITED_STATES_LIST.join('|')})`;
